const defaultDisplayedNumberSelectSearch = 10
export default defaultDisplayedNumberSelectSearch;
